import type { FC } from 'react'
import { CuesGroupTimingsWidget } from './cues-group-timings.widget.tsx'
import { cn } from '@/utils'
import { GroupRange, type GroupTiming } from '@/entities/cues-group'
import { DimmedDuration } from '@/shared/ui/dimmed-duration'
import { isBefore, isAfter, addSeconds } from 'date-fns'
import { roundMsToSeconds } from '@rundown-studio/timeutils'

type CuesGroupActiveTimingProps = {
  groupTiming: GroupTiming
  timezone?: string | null
  todDisplayFormat?: '24h' | '12hNoAmPm' | '12h' | null
}

export const CuesGroupActiveTiming: FC<CuesGroupActiveTimingProps> = ({
  groupTiming,
  timezone,
  todDisplayFormat,
}) => {
  if (!groupTiming || groupTiming.countdown === null) return null

  // Check if we're overtime (rounded to seconds)
  const isOverdue = roundMsToSeconds(groupTiming.countdown) <= 0

  return (
    <CuesGroupTimingsWidget
      className="bg-gray-900 py-0.5"
      Duration={
        <DimmedDuration
          className={cn(
            'text-sm opacity-50',
            isOverdue && 'text-red-600 opacity-100',
          )}
          ms={groupTiming.countdown}
        />
      }
      Range={
        <GroupRange
          start={groupTiming.actual.start}
          end={groupTiming.actual.end}
          timezone={timezone}
          separatorClassName="opacity-50"
          startClassName={cn(
            'opacity-50',
            isBefore(groupTiming.actual.start, groupTiming.original.start) &&
              'text-green-600 opacity-100',
            isAfter(
              groupTiming.actual.start,
              addSeconds(groupTiming.original.start, 1),
            ) && 'text-red-600 opacity-100',
          )}
          endClassName={cn(
            'opacity-50',
            isBefore(groupTiming.actual.end, groupTiming.original.end) &&
              'text-green-600 opacity-100',
            isAfter(
              groupTiming.actual.end,
              addSeconds(groupTiming.original.end, 1),
            ) && 'text-red-600 opacity-100',
          )}
          todDisplayFormat={todDisplayFormat}
        />
      }
    />
  )
}
